import axios from "axios";

const instance = axios.create({
  baseURL: "https://floating-tor-56690.herokuapp.com",
});

export default instance;
